import type { LookupItem } from '../mocks/criminalMasterData';
import type { CriminalSaveStep4, PhysicalFileDeliveryMethodRow } from '../types/criminalApi';
import type { CriminalWizardDraft } from '../types/criminalCaseRequest';
import { isOtherLookup } from './criminalConstants';

function formatOtherDeliveryLabel(label: string, otherText?: string): string {
  const other = otherText?.trim();
  if (other) return `${label} - ${other}`;
  return label;
}

function deliveryLabelsFromStep4(step4?: CriminalSaveStep4): string[] | null {
  const raw = step4?.physical_file_delivery_methods;
  if (!raw?.length || typeof raw[0] === 'string') return null;

  const labels = (raw as PhysicalFileDeliveryMethodRow[])
    .map((row) => {
      const name = row.delivery_method_name?.trim() ?? '';
      if (!name) return '';
      const other = row.other_method?.trim();
      if (isOtherLookup(name)) return formatOtherDeliveryLabel(name, other);
      return name;
    })
    .filter(Boolean);

  return labels.length ? labels : null;
}

export function deliveryMethodDisplay(
  draft: CriminalWizardDraft,
  deliveryMethods: LookupItem[] = [],
  step4?: CriminalSaveStep4,
): string {
  const fromStep4 = deliveryLabelsFromStep4(step4);
  if (fromStep4?.length) return fromStep4.join(', ');

  const stepOther = (step4?.other_method ?? step4?.otherMethod)?.trim();

  if (draft.deliveryMethodIds.length) {
    const names = draft.deliveryMethodIds
      .map((id) => {
        const item = deliveryMethods.find((m) => m.id === id);
        if (item && isOtherLookup(item.name, item.code ?? item.id)) {
          return formatOtherDeliveryLabel(item.name, draft.deliveryOther || stepOther);
        }
        return item?.name ?? id;
      })
      .filter(Boolean);
    if (names.length) return names.join(', ');
  }

  if (draft.deliveryMethods.length) {
    return draft.deliveryMethods
      .map((name) => {
        if (isOtherLookup(name)) return formatOtherDeliveryLabel(name, draft.deliveryOther || stepOther);
        return name;
      })
      .join(', ');
  }

  return '—';
}
